import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import React, { useEffect } from 'react';
import styles from '../index.module.scss';
import { IRenderingEngine } from '../interfaces/index.type';
import TextArea from '@primitives/TextArea';
import Typography from '@primitives/Typography';

const TextAreaInput: React.FC<IRenderingEngine> = props => {
  const { question, register, error, source, setValue, unregister, clearErrors } = props;
  const { text, mandatory, defaultValue, referenceId, metadata } = question;
  const { placeholder, validators } = metadata || {};

  const { validatorMeta, validatorRegexes } = validators || {};

  const isValidatorEnabled = validatorMeta?.isRequired;

  const validationRules = {
    required: {
      value: mandatory,
      message: 'Please enter call summary.'
    },
    validate: (inputValue: string) => {
      if (isValidatorEnabled && validatorRegexes) {
        for (const validatorIndex in validatorRegexes) {
          const { regexString, shouldMatchRegex, errorMessage } = validatorRegexes[validatorIndex];
          const pattern = new RegExp(regexString);
          const matchesPattern = pattern.test(inputValue);
          if (shouldMatchRegex !== matchesPattern) {
            return errorMessage;
          }
        }
      }
      return true;
    }
  };

  useEffect(() => {
    return () => {
      setValue(`${source}_${referenceId}`, undefined);
      unregister(`${source}_${referenceId}`);
      clearErrors(`${source}_${referenceId}`);
    };
  }, []);

  return (
    <div className={styles.input}>
      <Typography variant={'p4'} as={'p'} className={styles.label}>
        {text} {mandatory && <RequiredIcon />}
      </Typography>
      <TextArea
        value={defaultValue || ''}
        error={!!error?.[`${source}_${referenceId}`]}
        {...register(`${source}_${referenceId}`, validationRules)}
        placeholder={placeholder?.length > 0 ? placeholder : 'Type here'}
        id="textarea"
        resize
        fullWidth
        rows={4}
        containerClassName={styles.textAreaContainer}
        className={styles.textAreaContainer}
      />
      {error?.[`${source}_${referenceId}`] ? (
        <Typography variant="p5" className={styles.errorText}>
          {error[`${source}_${referenceId}`]?.message?.toString()}
        </Typography>
      ) : null}
    </div>
  );
};

export default TextAreaInput;
